import { useBreadcrumb } from '../hooks/useBreadcrumb';

const TermArrow = () => {
	const { blockClass, caretIconSize } = useBreadcrumb();

	const renderClass = () => {
		return (
			blockClass &&
			`arrow--${blockClass} termArrow--${blockClass} vtex-breadcrumb-1-x-arrow--${blockClass} vtex-breadcrumb-1-x-termArrow--${blockClass}`
		);
	};

	return (
		<span className={`vtex-breadcrumb-1-x-arrow vtex-breadcrumb-1-x-termArrow ${renderClass()} ph2 c-muted-2`}>
			<svg
				fill="none"
				width={caretIconSize}
				height={caretIconSize}
				viewBox="0 0 16 16"
				className={`caretIcon ${blockClass ? `caretIcon--${blockClass}` : ''} tex-breadcrumb-1-x-caretIcon vtex-breadcrumb-1-x-caretIcon--${blockClass}`}
				xmlns="http://www.w3.org/2000/svg"
			>
				<g id="nav-caret--right">
					<path
						d="M12.1948 7.26254C12.6276 7.65892 12.6276 8.34108 12.1948 8.73746L4.26471 16L2 13.9259L8.47059 8L2 2.07407L4.26471 0L12.1948 7.26254Z"
						fill="currentColor"
					/>
				</g>
			</svg>
		</span>
	);
};

export default TermArrow;
